import { useWorkspaceLocale } from "src/contexts/global/WorkspaceContext";
import { getDateFormats } from "src/localization/dateFormats";

/**
 * Returns locale-aware date format strings for the current workspace.
 *
 * Usage:
 *   const { short, readable, readableDateTime } = useWorkspaceDateFormats();
 *   moment(date).format(readable); // "DD MMM YYYY" for en-AU/en-GB, "MMM DD, YYYY" for en-US
 *
 * Format keys:
 *   short              - "DD/MM/YYYY" | "MM/DD/YYYY"
 *   shortDateTime      - "DD/MM/YYYY HH:mm:ss" | "MM/DD/YYYY HH:mm:ss"
 *   readable           - "DD MMM YYYY" | "MMM DD, YYYY"
 *   readableDateTime   - "hh:mma DD MMM YYYY" | "hh:mma MMM DD, YYYY"
 *   readableDateTimeFilename - "YYYYMMDD-HHmm" (same across all locales)
 *   columnHeader       - non-breaking-space variant of readable
 */
const useWorkspaceDateFormats = () => {
  const locale = useWorkspaceLocale();
  return getDateFormats(locale);
};

export default useWorkspaceDateFormats;
